import { reskinStyles } from 'core/components/theme/theme-variant';

const styles = (theme) => ({
  label: {
    color: theme.colors.info__label_primary,
    display: 'inline'
  },
  'dark-label': {
    color: `${theme.colors.light_text} !important`
  },
  'dark-colorSecondary': {
    '&:.Mui-disabled': {
      color: `${theme.colorPalette.orange_50_op_70} !important`
    }
  },
  switchTooltip: {
    position: 'relative',
    left: theme.spacing(11),
    top: '-10px',
    // Reskin: under the label of quote's smaller 48x24 toggle (48px + 8px gap).
    ...reskinStyles(theme, { left: theme.spacing(14), top: 0 })
  },
  container: {
    marginTop: 0,
    minHeight: 45
  }
});

export default styles;
